const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const getMenu = (component) => {
  return [
    {
      text: "Quem Somos",
      to: "/quem-somos",
    },
    {
      text: "Tipos de Cestas",
      dropdown: component.baskets,
    },
    {
      text: "Tipos de Flores",
      dropdown: component.flowers,
    },
    {
      text: "Ocasiões",
      dropdown: component.occasions,
    },
    // {
    //   text: "Promoções",
    //   to: "/promocoes",
    // },
    {
      text: "Fale Conosco",
      to: "/fale-conosco",
    },
  ];
};

export { server, getMenu };
